export default {
  
  subscriptionSuccessData(state){
    return state.subscriptionSuccessData
  },
  subscriptionErrorMessage(state){
    return state.subscriptionErrorMessage
  },

  failedToDeleteSubscription(state){
    return state.failedToDeleteSubscription
  },
  subscriptionDeleted(state){
    return state.subscriptionDeleted
  },

  failedToListActiveSubscription(state){
    return state.failedToListActiveSubscription
  },

  subscriptionList(state){
    return state.subscriptionList
  },

  whitelisted(state){
    return state.whitelisted
  },

  failedToFetchCardList(state){
    return state.failedToFetchCardList
  },
  cardLists(state){
    return state.cardLists
  },

  failedToListInvoice(state){
    return state.failedToListInvoice
  },
  invoiceList(state){
    return state.invoiceList
  },

  failedToDelete(state){
    return state.failedToDelete
  },

  listSubscriptionPlans(state) {
    return state.listSubscriptionPlans;
  },
  failedToFetchPlansInfo(state) {
    return state.failedToFetchPlansInfo;
  },

  failedToFetchProductListMessage(state) {
    return state.failedToFetchProductListMessage;
  },
  userBasedPlanInfo(state) {
    return state.userBasedPlanInfo;
  },
};
